import { LazyPage, PipelineAddDestinationPage } from './-components';
import { createFileRoute } from '@tanstack/react-router';

function PipelineAddDestinationRoute() {
  return (
    <LazyPage>
      <PipelineAddDestinationPage />
    </LazyPage>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/pipelines/destinations/add')({
  component: PipelineAddDestinationRoute,
});
